// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslateMsgProvider {

	constructor(public translate: TranslateService)
	{}

	getLng()
	{
    	return this.translate.getDefaultLang();
	}

	getMsg(msg, extra = '')
	{
		let mensagens;
    	let lng = this.translate.getDefaultLang();
		
		if(lng == 'pt')
		{
			mensagens = this.getMsgPt(extra);
		}
		else if(lng == 'en')
		{
			mensagens = this.getMsgEn(extra);
		}
		else
		{
			mensagens = this.getMsgEs(extra);
		}

		return mensagens[msg];
	}

	getMsgPt(extra)
	{
		let mensagens;

		mensagens = {
			'CARREGANDO' : 'Carregando',
			'NAO'        : 'Não',
			'CANCELAR'   : 'Cancelar',
			'SALVAR'     : 'Salvar',
			'BEMVINDO'   : 'Bem-vindo!',

			'MENU_CARTAO'      : 'Meu cartão',
			'MENU_DADOS'       : 'Meus dados',
			'MENU_INFORMACOES' : 'Informações da empresa',
			'MENU_REGRAS'      : 'Regras da promoção',
			'MENU_MENSAGENS'   : 'Mensagens',
			'MENU_HISTORICO'   : 'Histórico de Pontos',
			'MENU_SOBRE'       : 'Sobre',
			'MENU_OUTRALOJA'   : 'Escolher outra loja',
			'MENU_IDIOMA'      : 'Mudar Idioma',
			'MENU_SAIR'        : 'Sair',

			'ERRO'                     : 'Erro',
			'ERRO_FACEBOOK'            : 'Erro ao conectar ao Facebook. Tente novamente.',
			'ERRO_DADOS'               : 'Por favor preencha os dados.',
			'ERRO_EMAIL'               : 'Por favor preencha o e-mail com um endereço válido.',
			'ERRO_CADASTRO'            : 'Erro ao se cadastrar',
			'ERRO_ACESSO'              : 'Acesso negado',
			'ERRO_CODIGO'              : 'Insira o código.',
			'CARTAO_SENHA_ERRO'        : 'Senha incorreta.',
			'CARTAO_ERRO_PARTICIPACAO' : 'Erro ao salvar sua participação.',
			'ERRO_ALTERACAO'           : 'Nenhuma alteração realizada.',

			'SUCESSO'         : 'Sucesso',
			'SUCESSO_CONTA'   : 'Conta criada!',
			'SUCESSO_EDITADO' : 'Dados editados com sucesso',

			'RECUPERACAO_SENHA_TITULO' : 'Recuperação de Senha',
			'RECUPERACAO_SENHA_MSG1'   : 'E-mail não encontrado na nossa base de dados. Verifique se seu e-mail está escrito corretamente.',
			'RECUPERACAO_SENHA_MSG2'   : 'Erro ao enviar o e-mail. Por favor, tente novamente mais tarde.',
			'RECUPERACAO_SENHA_MSG3'   : 'Uma mensagem foi enviada para o e-mail digitado com um código de validação.',
			'RECUPERACAO_SENHA_MSG4'   : 'Código não encontrado.',
			'RECUPERACAO_SENHA_MSG5'   : 'Sua senha foi alterada com sucesso.',
			'RECUPERACAO_SENHA_MSG6'   : 'Erro ao alterar sua senha.',

			'CARTAO_PARTICIPAR'       : 'Deseja participar do cartão '+extra+'?',
			'CARTAO_PARTICIPAR_DESC'  : 'Você deseja participar do cartão '+extra+' e receber seu ponto?',
			'CARTAO_PARTICIPAR_SIM'   : 'Quero participar',
			'CARTAO_FALTA_UM_PONTO'   : 'Falta 1 ponto',
			'CARTAO_FALTA_PONTOS'     : 'Faltam '+extra+' pontos',
			'CARTAO_AVISO_ADICIONADO' : 'Seu ponto foi adicionado no cartão. '+extra+' para você completar o cartão. Continue pontuando!',
			'CARTAO_AVISO_ZERADO' 	  : 'Seu cartão foi zerado com sucesso!',
			'CARTAO_PARABENS'         : 'Parabéns! Você completou o cartão fidelidade e pode retirar seu prêmio na sua próxima visita.',
			'CARTAO_ESCOLHA_ESTADO'   : 'Escolha o estado para continuar.',
			'CARTAO_ESCOLHA_CIDADE'   : 'Escolha a cidade para continuar.',

			'CARTAO_VALIDAR'          : 'Validar',
			'CARTAO_SENHA'            : 'Coloque a senha de administrador',
			'CARTAO_PARTICIPANDO'     : 'Agora você está participando do cartão fidelidade '+extra,
			'CARTAO_BEMVINDO'         : 'Bem-vindo e aproveite!',
			'CARTAO_NAOQUERO'         : 'Não quero mais participar',
			'CARTAO_NAOQUERO_ATENCAO' : '<b>Atenção!</b><br>Ao sair desse cartão você irá perder as estrelas recebidas e não receberá mais as notificações da empresa com promoções.',
			'CARTAO_NAOQUERO_SAIR'    : 'Sair mesmo assim',

			'CARTAO_CONTATO': 'Contato - cartão fidelidade',
			
			'MENSAGEM_1'              : 'Olá '+extra+', tudo bem?',
			'MENSAGEM_2'              : 'Você tem alguma pergunta, sugestão ou reclamação? Fale com a gente! Nós iremos responder o mais rápido possível.',
			'MENSAGEM_ENVIANDO'       : 'Enviando',
			'MENSAGEM_ENVIADO'        : 'Enviado!',

			'ADICIONAR_TITULO' : 'Adicionar estrela',
			'ADICIONAR_OPC' : 'Como você deseja adicionar uma estrela?',
			'ADICIONAR_OPC_2' : 'Você quer adicionar uma estrela?',
			'ADICIONAR_SENHA' : 'Senha',
			'ADICIONAR_QRCODE' : 'QRCode',

			'SHARE_TITULO': 'Cartão Fidelidade',
			'SHARE_MSG': 'A empresa '+extra+' utiliza o Cartão Fidelidade Digital'
		};

		return mensagens;
	}

	getMsgEn(extra)
	{
		let mensagens;

		mensagens = {
			'CARREGANDO' : 'Loading',
			'NAO'        : 'No',
			'CANCELAR'   : 'Cancel',
			'SALVAR'     : 'Save',
			'BEMVINDO'   : 'Welcome!',
			
			'MENU_CARTAO'      : 'My card',
			'MENU_DADOS'       : 'My data',
			'MENU_INFORMACOES' : 'Company info',
			'MENU_REGRAS'      : 'Promotion rules',
			'MENU_MENSAGENS'   : 'Messages',
			'MENU_HISTORICO'   : 'Points history',
			'MENU_SOBRE'       : 'About',
			'MENU_OUTRALOJA'   : 'Choose another store',
			'MENU_IDIOMA'      : 'Change language',
			'MENU_SAIR'        : 'Logout',

			'ERRO'                     : 'Error',
			'ERRO_FACEBOOK'            : 'Error connecting to Facebook. Try again.',
			'ERRO_DADOS'               : 'Please fill in the information.',
			'ERRO_EMAIL'               : 'Please fill in the e-mail with a valid address.',
			'ERRO_CADASTRO'            : 'Error registering',
			'ERRO_ACESSO'              : 'Access denied',
			'ERRO_CODIGO'              : 'Enter code.',
			'CARTAO_SENHA_ERRO'        : 'Incorrect password.',
			'CARTAO_ERRO_PARTICIPACAO' : 'Error saving your participation.',
			'ERRO_ALTERACAO'           : 'No change made.',
			
			'SUCESSO': 'Success',
			'SUCESSO_CONTA': 'Account created!',
			'SUCESSO_EDITADO' : 'Data edited successfully',

			'RECUPERACAO_SENHA_TITULO': 'Password recovery',
			'RECUPERACAO_SENHA_MSG1': 'Email not found in our database. Make sure your email is spelled correctly.',
			'RECUPERACAO_SENHA_MSG2': 'Error sending the e-mail. Please try again later.',
			'RECUPERACAO_SENHA_MSG3': 'A message was sent to the email typed with a validation code.',
			'RECUPERACAO_SENHA_MSG4': 'Code not found.',
			'RECUPERACAO_SENHA_MSG5': 'Your password has been changed successfully.',
			'RECUPERACAO_SENHA_MSG6': 'Error changing your password.',

			'CARTAO_PARTICIPAR'       : 'Do you want to participate in the card '+extra+'?',
			'CARTAO_PARTICIPAR_DESC'  : 'Do you want to participate in the '+extra+' card and receive your point?',
			'CARTAO_PARTICIPAR_SIM'   : 'I want to participate',
			'CARTAO_FALTA_UM_PONTO'   : '1 point is missing',
			'CARTAO_FALTA_PONTOS'     : 'Missing '+extra+' points',
			'CARTAO_AVISO_ADICIONADO' : 'Your point has been added to the card. '+extra+' for you to complete the card. Keep punctuating!',
			'CARTAO_AVISO_ZERADO' 	  : 'Your card has been reset with success!',
			'CARTAO_PARABENS'         : 'Congratulations! You have completed your loyalty card and can withdraw your prize on your next visit.',
			'CARTAO_ESCOLHA_ESTADO'   : 'Select the state to continue.',
			'CARTAO_ESCOLHA_CIDADE'   : 'Choose the city to continue.',

			'CARTAO_VALIDAR'          : 'Validate',
			'CARTAO_SENHA'            : 'Enter the administrator password',
			'CARTAO_PARTICIPANDO'     : 'You are now participating in the '+extra+' loyalty card',
			'CARTAO_BEMVINDO'         : 'Welcome and enjoy!',
			'CARTAO_NAOQUERO'         : "I DON'T WANT TO PARTICIPATE ANYMORE",
			'CARTAO_NAOQUERO_ATENCAO' : '<b>Attention!</b><br>When you leave this card you will lose the stars you received and will no longer receive the company notifications with promotions.',
			'CARTAO_NAOQUERO_SAIR'    : 'Leave anyway',

			'CARTAO_CONTATO': 'Contact - loyalty card',
			
			'MENSAGEM_1'              : 'hello '+extra+', alright?',
			'MENSAGEM_2'              : 'Do you have any questions, suggestions or complaints? Talk to us! We will respond as soon as possible. ',
			'MENSAGEM_ENVIANDO'       : 'Sending',
			'MENSAGEM_ENVIADO'        : 'Sent!',

			'ADICIONAR_TITULO' : 'Add one star',
			'ADICIONAR_OPC' : 'How do you want to add a star?',
			'ADICIONAR_OPC_2' : 'Do you want to add a star?',
			'ADICIONAR_SENHA' : 'Password',
			'ADICIONAR_QRCODE' : 'QRCode',

			'SHARE_TITULO': 'Digital loyalty card',
			'SHARE_MSG': 'The '+extra+' company uses the Digital Loyalty Card'
		};

		return mensagens;
	}

	getMsgEs(extra)
	{
		let mensagens;

		mensagens = {
			'CARREGANDO' : 'Cargando',
			'NAO'        : 'no',
			'CANCELAR'   : 'Cancelar',
			'SALVAR'     : 'Guardar',
			'BEMVINDO'   : 'Bienvenido',

			'MENU_CARTAO'      : 'Mi tarjeta',
			'MENU_DADOS'       : 'Mis datos',
			'MENU_INFORMACOES' : 'Información de la compañía',
			'MENU_REGRAS'      : 'Reglas de promoción',
			'MENU_MENSAGENS'   : 'Mensajes',
			'MENU_HISTORICO'   : 'Historial de puntos',
			'MENU_SOBRE'       : 'Acerca de',
			'MENU_OUTRALOJA'   : 'Elige otra tienda',
			'MENU_IDIOMA'      : 'Cambiar idioma',
			'MENU_SAIR'        : 'Cerrar sesión',

			'ERRO'                     : 'Error',
			'ERRO_FACEBOOK'            : 'Error al conectarse a Facebook. Inténtalo de nuevo.',
			'ERRO_DADOS'               : 'Por favor, rellene los datos.',
			'ERRO_EMAIL'               : 'Por favor, rellene el correo electrónico con una dirección válida.',
			'ERRO_CADASTRO'            : 'Error al registrarse',
			'ERRO_ACESSO'              : 'Acceso denegado',
			'ERRO_CODIGO'              : 'Introduzca el código.',
			'CARTAO_SENHA_ERRO'        : 'Contraseña incorrecta.',
			'CARTAO_ERRO_PARTICIPACAO' : 'Error al guardar su participación.',
			'ERRO_ALTERACAO'           : 'Ninguna modificación realizada.',

			'SUCESSO'         : 'Éxito',
			'SUCESSO_CONTA'   : '¡Cuenta creada!',
			'SUCESSO_EDITADO' : 'Datos editados con éxito',

			'RECUPERACAO_SENHA_TITULO' : 'Recuperación de Contraseña',
			'RECUPERACAO_SENHA_MSG1'   : 'E-mail no encontrado en nuestra base de datos. Asegúrese de que su correo electrónico está escrito correctamente. ',
			'RECUPERACAO_SENHA_MSG2'   : 'Erro ao enviar o e-mail. Por favor, tente novamente mais tarde.',
			'RECUPERACAO_SENHA_MSG3'   : 'Un mensaje se envió al correo electrónico introducido con un código de validación.',
			'RECUPERACAO_SENHA_MSG4'   : 'Código no encontrado.',
			'RECUPERACAO_SENHA_MSG5'   : 'Su contraseña ha cambiado con éxito.',
			'RECUPERACAO_SENHA_MSG6'   : 'Error al cambiar su contraseña.',

			'CARTAO_PARTICIPAR'       : '¿Desea participar en la tarjeta '+extra+'?',
			'CARTAO_PARTICIPAR_DESC'  : '¿Quieres participar en la tarjeta '+extra+' y recibir tu punto?',
			'CARTAO_PARTICIPAR_SIM'   : 'Quiero participar',
			'CARTAO_FALTA_UM_PONTO'   : 'Falta 1 punto',
			'CARTAO_FALTA_PONTOS'     : 'Faltan '+extra+' puntos',
			'CARTAO_AVISO_ADICIONADO' : 'Su punto fue agregado en la tarjeta. '+extra+' para completar la tarjeta. ¡Continúe puntuando!',
			'CARTAO_AVISO_ZERADO' 	  : 'Los puntos de su tarjeta fue reiniciado con exito!',
			'CARTAO_PARABENS'         : '¡Enhorabuena! Usted ha completado la tarjeta de fidelidad y puede retirar su premio en su próxima visita.',
			'CARTAO_ESCOLHA_ESTADO'   : 'Elija el estado para continuar.',
			'CARTAO_ESCOLHA_CIDADE'   : 'Escoge la ciudad para continuar.',


			'CARTAO_VALIDAR'          : 'Validar',
			'CARTAO_SENHA'            : 'Ponga la contraseña de administrador',
			'CARTAO_PARTICIPANDO'     : 'Ahora estás participando en la tarjeta de fidelidad '+extra,
			'CARTAO_BEMVINDO'         : 'Bienvenido y disfruta!',
			'CARTAO_NAOQUERO'         : 'No quiero participar más',
			'CARTAO_NAOQUERO_ATENCAO' : '<b>Atención!</b> Al salir de esa tarjeta usted perderá las estrellas recibidas y no recibirá más las notificaciones de la empresa con promociones.<br>',
			'CARTAO_NAOQUERO_SAIR'    : 'Salir aún así',

			'CARTAO_CONTATO': 'Contacto - tarjeta de fidelidad',
			
			'MENSAGEM_1'              : '¿Hola '+extra+' todo bien?',
			'MENSAGEM_2'              : '¿Tienes alguna pregunta, sugerencia o queja? Hable con nosotros. Nosotros responderemos lo más rápido posible.',
			'MENSAGEM_ENVIANDO'       : 'Enviando',
			'MENSAGEM_ENVIADO'        : 'Publicado!',

			'ADICIONAR_TITULO' : 'Añadir una estrella',
			'ADICIONAR_OPC' : '¿Cómo desea añadir una estrella?',
			'ADICIONAR_OPC_2' : '¿Quieres añadir una estrella?',
			'ADICIONAR_SENHA' : 'Contraseña',
			'ADICIONAR_QRCODE' : 'QRCode',

			'SHARE_TITULO': 'Tarjeta de Fidelidad',
			'SHARE_MSG': 'La empresa '+extra+' utiliza la Tarjeta Fidelidad Digital'
		};

		return mensagens;
	}
}



// WEBPACK FOOTER //
// ./src/providers/translate-msg/translate-msg.ts